import LuckySpin from './lucky-spin';

export default LuckySpin;
